import { Check } from "lucide-react";

export function SignalGrid({ catalog, selected, onToggle, testIdPrefix }) {
  const cats = catalog.signals || {};
  const order = ["hiring", "website", "ads", "social", "tech", "expansion"];
  return (
    <div className="space-y-3">
      {order.filter((c) => cats[c]).map((cat) => (
        <div key={cat}>
          <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500 mb-1.5">
            {STATUS_LABEL(cat)} signals
          </div>
          <div className="flex flex-wrap gap-1.5">
            {(cats[cat] || []).map((s) => {
              const active = selected.includes(s.id);
              return (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => onToggle(s.id)}
                  data-testid={`${testIdPrefix}-${s.id}`}
                  className={`text-[11px] rounded-full px-2 py-1 font-semibold border transition-colors ${
                    active
                      ? "bg-blue-600 border-blue-600 text-white"
                      : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"
                  }`}
                >
                  {active && <Check className="w-2.5 h-2.5 inline mr-1" />}
                  {s.label}
                  <span className={`ml-1 text-[9px] ${active ? "text-blue-100" : "text-slate-400"}`}>
                    +{s.weight}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

// ===========================================================================
// CSV import dialog
